
/**************
* Smooth anchor scroll
*/ 
$('a.anchor:not([href="#"])').on('click', function(event){
    event.preventDefault();
    event.stopImmediatePropagation();

    // Fa ricalcolare a slick l'altezza, altrimenti lo slider presente nella tab nascosta risulta alto 0 e quindi non si vede
    //$('.slider-gallery').slick('setPosition');

    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {

            // se scrolli con il mouse si interrompe lo smooth scroll
            $('html, body').bind('mousewheel', function(e){ 
                $(this).stop();
            });

            $('html').animate({
                scrollTop: target.offset().top 
            }, 600);

            /*$('html, body').animate({
                    scrollTop: target.offset().top -130
                }, 1000);*/

            return false;
        }
    }
});



/**************
* Back to top
*/ 

$(window).scroll(function() {
    if ($(this).scrollTop() >= 900) {       
        $('.back-to-top').fadeIn(200);    
    } else {
        $('.back-to-top').fadeOut(200);   
    }
});
$('.back-to-top').click(function() {   
    console.log('clic');
    $('body,html').animate({
       scrollTop: 0            
    }, 500);
});


/**************
* Quantity
*/ 

/*
$(document).on('click', '.quantity .plus', function(e) {
    e.preventDefault();

    // Read current quantity
    var qtyInput = $(this).parent().find('[type="number"].qty');
    var currQty = parseInt(qtyInput.val());

    // Updated quantity
    var newQty = currQty + 1;

    // Update inputs
    qtyInput.val(newQty).change();

});

$(document).on('click', '.quantity .minus', function(e) {
    e.preventDefault();

    // Read current quantity
    var qtyInput = $(this).parent().find('[type="number"].qty');
    var currQty = parseInt(qtyInput.val());

    // If there's at least 1 item
    if (currQty > 0) {
        // Updated quantity
        var newQty = currQty - 1;

        // Update inputs
        qtyInput.val(newQty).change();

    }
});
*/



// Polyfill per IE11
//https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill

(function(){
    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent (event, params) {
        params = params || {bubbles: false, cancelable: false, detail: null};
        var evt = document.createEvent( 'CustomEvent');
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();


$(document).ready(function(){

    // Read more
    $('.js-more').on('click',function(e){
        e.preventDefault();
        $(this).next('div').slideToggle('slow');
        $(this).text($(this).text() == 'Leggi di più' ? 'Leggi meno' : 'Leggi di più');
    })


    //Accordion

    $('.accordion .accordion__item.accordion__content').show();

    var item = document.querySelectorAll('.accordion__item');
    for(var i = 0; i < item.length; i++) {
        item[i].classList.add('js-item');
        //console.log(title[i].classList);
    }

    var title = document.querySelectorAll('.accordion__header');
    for(var i = 0; i < title.length; i++) {
        title[i].classList.add('js-header');
        //console.log(title[i].classList);
    }

    var copy = document.querySelectorAll('.accordion__content');
    for(var i = 0; i < copy.length; i++) {
        copy[i].classList.add('js-content');
        //console.log(copy[i].classList);
    }

    $('.accordion .js-content').slideUp();    
    $('.accordion__item .js-header').attr('aria-expanded','false');

    // Primo elemento aperto
    //$('.accordion .accordion__item:first-child .js-header').toggleClass('active');
    //$('.accordion .accordion__item:first-child .js-content').slideDown();
    //$('.accordion__item:first-child .js-header').attr('aria-expanded','true');



    //var $title = $('.accordion .js-header');

    /*
    $('.accordion .js-header').click(function () {
        $(this).next(copy).slideToggle();
        $(this).parent().siblings().children().next().slideUp();
    */
    $('header .js-header').click(function () {
        $(this).next(copy).toggle();
        $(this).parent().siblings().children().next().hide();
        $(this).toggleClass('active');

        $(this).parent().siblings().children().removeClass('active');


        // toggle attributi
        if($(this).attr('aria-expanded') == 'true'){
            $(this).attr('aria-expanded','false');
        }

        else if($(this).attr('aria-expanded') == 'false'){
            $(this).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
        }

        return false;

    });

    var $item = $('.accordion .js-item'); // per la tastiera ridefinisco il selettore perché è l'item ad essere focusable a differenza del clic del mouse cha va sull'header



    $item.keydown(function(e){ // usare keydown e non keyup perché così si può sovrascrivere il comportamento di default della space-bar che se selezionata fa scrollare la pagina


        var keyCode = e.keyCode || e.which;


        if(keyCode == 13 || keyCode == 32){    // all'invio o alla space-bar


            $(this).children(title).next(copy).slideToggle();
            $(this).siblings().children().next().slideUp();
            $(this).children(title).toggleClass('active');

            $(this).siblings().children().removeClass('active');


            if($(this).children(title).attr('aria-expanded') == 'true'){
                $(this).children(title).attr('aria-expanded','false');
            }

            else if($(this).children(title).attr('aria-expanded') == 'false'){
                $(this).children(title).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
            }

            return false;
        }

    });


    if (window.matchMedia("(max-width: 767px)").matches) {  

        $('.js-toggleMenu').on('click',function(e){
            e.preventDefault();
            $('body').toggleClass('nav-expanded');
            $(this).toggleClass('is-open');
            $(".primaryNav > ul li,.secondaryNav > .contentWrapWide ul li:not('.searchFormWrap')").toggle();

            if($('.mobileSearch').hasClass('is-open')){
                $('.mobileSearch').toggleClass('is-open');
            $('body').toggleClass('nav-expanded');
            };
        })

        $('.js-toggleSearch').on('click',function(e){
            e.preventDefault();
            $('body').toggleClass('nav-expanded');
            $('.mobileSearch').toggleClass('is-open');

            if($('.js-toggleMenu').hasClass('is-open')){
                $('.js-toggleMenu').removeClass('is-open');
                $(".primaryNav > ul li,.secondaryNav > .contentWrapWide ul li:not('.searchFormWrap')").toggle();
            $('body').toggleClass('nav-expanded');
            };
        })
        
               $('.js-closeSearch').on('click',function(e){
            e.preventDefault();
            $('body').toggleClass('nav-expanded');
            $('.mobileSearch').toggleClass('is-open');

            if($('.js-toggleMenu').hasClass('is-open')){
                $('.js-toggleMenu').removeClass('is-open');
                $(".primaryNav > ul li,.secondaryNav > .contentWrapWide ul li:not('.searchFormWrap')").toggle();
            $('body').toggleClass('nav-expanded');
            };
        })

        $('.menu-item.js-dropdown > a').on('click', function(event){
            event.preventDefault();
        });
        
         $('.js-openFilters').on('click',function(e){
            e.preventDefault();
            $('.filters').slideToggle();
            $('.openToggle').toggleClass('is-open');
        })


        if ($('.announcement').length){
            $('.logoNav').css('top','30px');
            $('body').css('padding-top','30px');
        }

        $('.js-announcement-close').on('click', function(event){
            $('.logoNav').css('top','0px');
            $('body').css('padding-top','0px');

            $('.announcement').css('transform','translateY(-100%)');

            mentCookies.set('bannerCovidClicked', 1, 1);

        });
        /*     $('.btn-search').on('click',function(e){
            e.preventDefault();
                 $('.searchFormWrap', '.searchForm').show();
        })*/
    }





      // tablet e desktop

    if (window.matchMedia("(min-width: 768px)").matches) {  
        $('.js-header').on('click', function(event){
            event.preventDefault();
            var selectedItem = $(this);
            selectedItem.toggleClass('selected').parent().siblings('li').children('div').toggleClass('is-visible');
            selectedItem.parent().siblings('li').children('a').toggleClass('selected');
            selectedItem.next('div').toggleClass('is-visible').show();
        });


/**************
* Fix aside menu on scroll
*/
        /*
        $(window).scroll(function(){
            var headerHeight = $("header").outerHeight();
            var bodyHeight = $(".twoColsWide__body").outerHeight();
            var footerHeight = $("footer").innerHeight();
            var asideMarginTop = headerHeight + 18;
            var asideHeight = $(".twoColsWide__aside").outerHeight();

            //posizione fixed dopo lo scroll header e prima che scrolli tutto il corpo pagine
            if ($(window).scrollTop() >= headerHeight + 70  && $(window).scrollTop() <= bodyHeight) {
                $('.twoColsWide__aside').css({
                    'top': asideMarginTop,
                    'bottom': 'auto',
                    'position': 'fixed',
                    //'width': '18%'
                });
                $('.twoColsWide__body').css({
                    'margin-left': '300px'
                });
            }
            
            // ritorno a posizione iniziale
            else if ($(window).scrollTop() <= headerHeight + 70) {
                $('.twoColsWide__aside').css({
                    'position': 'relative',
                    'top': '0'
                });
                $('.twoColsWide__body').css('margin-left', '50px') ;
            }

            //posizione finale, incui dopo lo scroll del corpo pagina viene appoggiato in fondo (necessario per evitare che rimanga fixed sul footer quando si crolla fino alla fine della pagina)
            else if ($(window).scrollTop() >= bodyHeight)  {
                $('.twoColsWide__aside').removeClass('is-fixed').css({
                    'position': 'absolute',
                    'top': 'auto',
                    'bottom': '0',
                }); 
            }





        });
*/

        /*
        //thanks to Chris Coyer https://css-tricks.com/dropdown-menus-with-more-forgiving-mouse-movement-paths/


var timer; 

$(".parent").on("mouseover", function() {
  clearTimeout(timer);
  openSubmenu();
}).on("mouseleave", function() {
  timer = setTimeout(
    closeSubmenu
  , 1000);
});

function openSubmenu() {
  $(".submenu").addClass("open");
}
function closeSubmenu() {
  $(".submenu").removeClass("open");
}
*/


        /*$('.js-dropdown').on('mouseenter', function(event){
            event.preventDefault();
            var selectedItem = $(this);
            selectedItem.children('a').addClass('selected').parent().siblings('li').children('div').removeClass('is-visible');
            selectedItem.siblings('li').children('a').removeClass('selected');
            selectedItem.children('a').next('div').addClass('is-visible').show();


        }).on('mouseleave', function(event){
            $(this).children('a').removeClass('selected');
            $(this).children('a').next('div').removeClass('is-visible');
        });*/




        function closeSubmenu() {
            // $(this).children('a').removeClass('selected');
            $(this).removeClass('is-visible');
        }

        /*  $('.primaryNavMenu .js-dropdown').children('a').hover(function(event){
            $('.primaryNavTools .js-content').removeClass('is-visible');
            $('.primaryNavTools .js-header').removeClass('selected').removeClass('active');
            $('.secondaryNav .js-content').removeClass('is-visible');
            $('.secondaryNav .js-header').removeClass('selected').removeClass('active');
            //$('body').addClass('darkOverlay');
        });


        $('.primaryNavTools .js-dropdown').children('a').hover(function(event){
            $('.primaryNavMenu .js-content').removeClass('is-visible');
            $('.primaryNavMenu .js-header').removeClass('selected').removeClass('active');
            //$('body').addClass('darkOverlay');
        });

          $('.secondaryNav .js-dropdown').children('a').hover(function(event){
            $('.primaryNavMenu .js-content').removeClass('is-visible');
            $('.primaryNavMenu .js-header').removeClass('selected').removeClass('active');
            $('.primaryNavTools .js-content').removeClass('is-visible');
            $('.primaryNavTools .js-header').removeClass('selected').removeClass('active');
            //$('body').removeClass('darkOverlay');
        });*/




        var $menu = $(".menu-item__content");


        $(document).click(function (e) {
            e.stopPropagation();


            //check if the clicked area is dropDown or not
            if ($('.js-dropdown').has(e.target).length === 0) {
                $('.menu-item__content').removeClass('is-visible').prev('a').removeClass('selected');
            }
        })


        // Ricerca + suggerimenti
        
        $("input[type='search']").on('focus', function(){
            //console.log('attribu');
           $(this).removeAttr('placeholder');
        });

        /* TODO da rimettere?
        $(".is-ajax-search input[type='search']").on('focusout', function(){
            $(".is-ajax-search-result").hide();

        });
        */

        $(".is-ajax-search input[type='search']").on('keyup', function(){
            $(".is-loader-image").show();

            var selected = $(this);

            if(selected.val().length >= 1){
                setTimeout(function() { 
                    selected.next(".is-loader-image").hide();
                    $(".is-ajax-search-result").show();
                }
                           , 700);
            }

            else{
                selected.next(".is-loader-image").hide();
                setTimeout(function() { 
                    $(".is-ajax-search-result").hide();    
                }
                           , 700);
            }
        });

        /* TODO da rimettere?
        $(".searchForm input[type='search']").on('focusout', function(){
            $(".is-ajax-search-result").hide();

        });
        */

        /*
        $(".searchForm input[type='search']").on('keyup', function(){
            $(".is-loader-image").show();
            
            var selected = $(this);

            if(selected.val().length >= 1){
                setTimeout(function() { 
                    selected.next(".is-loader-image").hide();
                    selected.parents('.searchFormWrap').next(".is-ajax-search-result").show();
                }
                           , 700);
            }

            else{
                selected.next(".is-loader-image").hide();
                setTimeout(function() { 
                    selected.parents('.searchFormWrap').next(".is-ajax-search-result").hide();    
                }
                           , 700);
            }
        });
        */

    }

    // Carrello: comando la form coupon dalla nostra "form" finta
    $(document).on('click', '#trigger_coupon', function(e) {
        e.preventDefault();
        $('#coupon_code').val($('#trigger_coupon_code').val());
        $('[name="apply_coupon"]').click();
    });

    // Cassa: comando la form coupon dalla nostra "form" finta
    $(document).on('click', '#trigger_coupon', function(e) {
        e.preventDefault();
        $('#coupon_code').val($('#trigger_coupon_code').val());
        $('form.checkout_coupon').submit();
    });


    // Cart remove item
    $(document).on('click', 'button.remove', function(e) {
        e.preventDefault();
        $(this).next('a.remove')[0].click();
    });




    // Loading su aggiunta al carrello
    $(".button-loading-wrap button").click(function(event){
        event.preventDefault();
        $(".view-cart").css('opacity','0');
        $(".button-loading-wrap").removeClass("cart-is-updated");
        $(this).parent().addClass("loading");
        
        /*
        setTimeout(function() {
            $(".button-loading-wrap").removeClass("loading").addClass("cart-is-updating");
            // For failed icon just replace ".done" with ".failed"
            //$(".done").addClass("finish");
        }, 2000);

        setTimeout(function() {
            $(".view-cart").css('opacity','1');
            $(".button-loading-wrap").removeClass("cart-is-updating").addClass("cart-is-updated");
            //$(".done").removeClass("finish");
            //$(".failed").removeClass("finish");
        }, 4000);
        */
    })

    $(document.body).on('added_to_cart', function(){
        //console.log('added_to_cart');

        $(".button-loading-wrap").removeClass("loading").addClass("cart-is-updating");

        setTimeout(function() {
            $(".view-cart").css('opacity','1');
            $(".button-loading-wrap").removeClass("cart-is-updating").addClass("cart-is-updated");
        }, 2000);
    });


    // Guida alla scelta
    $(".button-bar .next").click(function(event){
        event.preventDefault();
        
        var stepInput = $(this).parents('.pathStep').find(".options input:checked");
        var sectionTop = $(".path");
        
        if  (! stepInput.val()) {
            $(".error-tip").addClass('is-visible');
        }
        else {
            $(this).parents(".pathStep").addClass('is-hidden');

            var nextStepId = stepInput.data('nextstep');
            $(".pathStep#" + nextStepId).removeClass('is-hidden');

            $('html, body').animate({
                scrollTop: sectionTop.offset().top -120
            }, 450);

            /*
            if (! $(".pathStep#" + nextStepId).hasClass('is-hidden')) {
                $(this).parents('.path').addClass("results bg-gray-lightest bgSection");
            }
            */
        }
        
       /*
       if (! $(".last-step").hasClass('is-hidden')) {
            $(this).parents('.path').addClass("results bg-gray-lightest bgSection");
            
        }
        */
    })

    $(".button-bar .prev").click(function(event){
        event.preventDefault();
        var sectionTop = $(".path");

        $(this).parents(".pathStep").addClass('is-hidden');

        var prevStepId = $(this).data('prevstep');
        $(".pathStep#" + prevStepId).removeClass('is-hidden');

        //$('.path').removeClass("results bg-gray-lightest bgSection");
        $(".error-tip").removeClass('is-visible');

        $('html, body').animate({
            scrollTop: sectionTop.offset().top -120
        }, 450);

        /*
        $(this).parents(".pathStep").addClass('is-hidden');
        $(this).parents(".pathStep").prev().removeClass('is-hidden');
        $('.path').removeClass("results bg-gray-lightest bgSection");
        $(".error-tip").removeClass('is-visible');
        */
    })

    $(".radio-field").click(function(event){
        $(".error-tip").removeClass('is-visible');
    })


    // mgigli - Clic su banner Covid
    $(document).on('click', '.announcement a', function(e) {
        e.preventDefault();
        var myhref = $(this).attr('href');
        mentCookies.set('bannerCovidClicked', 1, 1);
        setTimeout(function() { window.location.href = myhref }, 500);
    });
    
    /* Google Autocomplete
     * https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform
     */

    /* IMPORTANT! */
    /* Include the libraries=places parameter when you first load the API.
       For example:  <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places"> */

    var placeSearch, autocomplete;

    function initAutocomplete() {
        // Create the autocomplete object, restricting the search to geographical
        // location types.

        var input = document.getElementById('billing_address_1');

        google.maps.event.addDomListener(input, 'keydown', function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        });

        autocomplete = new google.maps.places.Autocomplete(input, {types: ['geocode']});

        // When the user selects an address from the dropdown, populate the address
        // fields in the form.

        autocomplete.addListener('place_changed', fillInAddress);

    }

    // need to stop prop of the touchend event
    if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
        if (document.getElementsByClassName('pac-container').length) {
            setTimeout(function() {
                var container = document.getElementsByClassName('pac-container')[0];
                container.addEventListener('touchend', function(e) {
                    e.stopImmediatePropagation();
                });
            }, 500);
        }
    }

    function fillInAddress() {
        var componentForm = {
            street_number: {
                nameFormat: 'short_name',
                inputId: 'billing_address_1_number',
            },
            route: {
                nameFormat: 'long_name',
                inputId: 'billing_address_1',
            },
            administrative_area_level_2: {
                nameFormat: 'short_name',
                inputId: 'billing_state',
            },
            administrative_area_level_3: {
                nameFormat: 'long_name',
                inputId: 'billing_city',
            },
            /*
            country: {
                nameFormat: 'short_name',
                inputId: 'billing_country',
            },
            */
            postal_code: {
                nameFormat: 'short_name',
                inputId: 'billing_postcode',
            },
        };
        
        // Get the place details from the autocomplete object.
        var place = autocomplete.getPlace();

        for (var component in componentForm) {
            document.getElementById(componentForm[component].inputId).value = '';
            document.getElementById(componentForm[component].inputId).disabled = false;
        }

        // Get each component of the address from the place details
        // and fill the corresponding field on the form.
        if (typeof place !== 'undefined' && typeof place.address_components !== 'undefined') {
            for (var i = 0; i < place.address_components.length; i++) {
                //console.log(place.address_components[i]);

                var addressType = place.address_components[i].types[0];
                if (componentForm[addressType]) {
                    //console.log(addressType);

                    var val = place.address_components[i][componentForm[addressType].nameFormat];
                    var input = $('#'+componentForm[addressType].inputId);
                    
                    input.val(val);

                    input.trigger('change');
                    /*
                    if (input.is('select')) {
                        input.trigger('change');
                    }
                    */
                }
            }
        }
    }

    if ($('#billing_address_1').length > 0) {
        initAutocomplete();
    }
    
});



$(function () { // wait for document ready
    // init controller
    var controller = new ScrollMagic.Controller();
    
    // build scene
    var sceneHeaderPin = new ScrollMagic.Scene({triggerElement: ".header", triggerHook:"0"})
    //.setPin(".headerHome")
    .setPin(".header")
    .addTo(controller);
    
    
    //var sceneHeaderBg = new ScrollMagic.Scene({triggerElement: ".header", triggerHook:"0", offset: 15})
    var sceneHeaderBg = new ScrollMagic.Scene({triggerElement: ".headerHome", triggerHook:"0", offset: 15})
    .setClassToggle(".headerHome", "has-background")
    .addTo(controller);
});




/* Uncheck filters */
$('.fieldset__head button').on('click', function(event){
    event.preventDefault();

    //var selectedItem = $(this);
    $(this).parent('div').next('div').find('input:checkbox').removeAttr('checked');

    // Lancio l'evento change che fa scattare i filtri AJAX (uso solo il primo checkbox per evitare eventi multipli)
    $('form.filters [type="checkbox"]').first().change();
});


/*
// Store the window width 
var windowWidth = $(window).width();

// Resize Event 
$(window).resize(function(){
    // Check if the window width has actually changed and it's not just iOS triggering a resize event on scroll
    if ($(window).width() != windowWidth) {

        // Update the window width for next time
        windowWidth = $(window).width();

        setTimeout(function(){
            window.location.reload();
        });

    }
});
*/

// FALLBACK OBJECT-FIT IE
if(!Modernizr.objectfit) {
    $('.object-fit-wrap img').each(function(){
        //console.log("Sono in FALLBACK OBJECT-FIT IE");
        var imgSrc = $(this).attr('src');
        if (! imgSrc) imgSrc = $(this).attr('data-lazy');

        var fitType = 'cover';

        if($(this).data('fit-type')) {
            fitType = $(this).data('fit-type');
        }
        $(this).closest(".object-fit-wrap").addClass('is-active');
        $(this).closest(".object-fit-wrap").css({ 'background' : 'transparent url("'+imgSrc+'") no-repeat center center/'+fitType, });
        $(this).remove(); });
}

//cookies management helper
mentCookies = {
    set: function(name, value, days) {
        var components = [name + '=' + value];

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 3600 * 1000));

            // Test - scade dopo 1 min
            //date.setTime(date.getTime() + (60 * 1000));

            components.push('expires=' + date.toGMTString());
        }

        components.push('path=/');

        document.cookie = components.join('; ');
    },
    del: function(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    },
    get: function(name) {
        var start = name + '=',
            arr = document.cookie.split(';'),
            i;

        for(i = 0; i < arr.length; i++) {
            var item = arr[i].trim();

            if (item.indexOf(start) === 0){
                return item.substring(start.length);
            }
        }

        return null;
    }
}

function getUrlVars() {
	var vars = {};
	var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
		vars[key] = value;
	});
	return vars;
}
